import { lazy, Suspense, useState } from 'react'
import { TrendingUp } from 'lucide-react'

interface CurvaSData {
  mes: string
  previsto: number
  realizado: number
}

interface Props {
  obras: { id: string; nome: string }[]
  curvasPorObra: Record<string, CurvaSData[]>
  curvaConsolidada: CurvaSData[]
}

// Recharts é pesado (~250KB) — carrega sob demanda apenas quando o
// dashboard é montado. Mantém o bundle inicial do app enxuto.
const CurvaSChart = lazy(() => import('./DashboardCurvaSChart'))

export default function DashboardCurvaS({ obras, curvasPorObra, curvaConsolidada }: Props) {
  const [selectedObra, setSelectedObra] = useState<string>('all')

  const data = selectedObra === 'all' ? curvaConsolidada : (curvasPorObra[selectedObra] || [])

  const lastPoint = data.length > 0 ? data[data.length - 1] : null
  const statusCurva = lastPoint
    ? lastPoint.realizado >= lastPoint.previsto ? 'Adiantada' : lastPoint.previsto - lastPoint.realizado > 10 ? 'Atrasada' : 'No prazo'
    : null
  const statusCor = statusCurva === 'Adiantada' ? 'var(--emerald)' : statusCurva === 'Atrasada' ? 'var(--rose)' : 'var(--amber)'

  return (
    <div className="rounded-xl p-4 border" style={{ background: 'hsl(var(--bg2))', borderColor: 'hsl(var(--line))' }}>
      <div className="flex items-center gap-2 mb-4 flex-wrap">
        <TrendingUp size={14} className="text-primary" />
        <span className="text-sm font-bold text-foreground">Curva S — Avanço Previsto × Realizado</span>
        <select
          value={selectedObra}
          onChange={e => setSelectedObra(e.target.value)}
          className="ml-auto text-xs px-2 py-1 rounded-md bg-transparent border text-foreground"
          style={{ borderColor: 'hsl(var(--border))' }}
        >
          <option value="all">Consolidado</option>
          {obras.map(o => <option key={o.id} value={o.id}>{o.nome}</option>)}
        </select>
        {statusCurva && (
          <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{
            background: `hsl(${statusCor} / 0.15)`,
            color: `hsl(${statusCor})`,
          }}>{statusCurva}</span>
        )}
      </div>

      {data.length === 0 ? (
        <div className="text-xs text-muted-foreground text-center py-8">
          Dados insuficientes para gerar a curva S. Registre mais RDOs para visualizar.
        </div>
      ) : (
        <Suspense fallback={
          <div className="h-[260px] flex items-center justify-center text-xs text-muted-foreground">
            Carregando gráfico...
          </div>
        }>
          <CurvaSChart data={data} />
        </Suspense>
      )}
    </div>
  )
}
